import { render, staticRenderFns } from "./FooterLoginComponent.vue?vue&type=template&id=2e50f4ce&"
import script from "./FooterLoginComponent.vue?vue&type=script&lang=js&"
export * from "./FooterLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports